const env = process.env.NODE_ENV;
const SUPPORT_EMAIL = 'support@panelfox.io';
const location_host = window.location.host;

function getDefaultUiUrl() {
    let ui_url = (env == 'production') ? 'https://panelfox.io' : 'http://localhost:3000';
    const domain_array = window.location.host.split('.');
    if (domain_array.length == 3) {
        if (domain_array[0] == 'eu') {
            ui_url = 'https://eu.panelfox.io';
        }
    }
    return ui_url;
}

function getDefaultApiUrl() {
    let api_url = (env == 'production') ? 'https://api.panelfox.io/api' : 'http://localhost:8888/api';
    const api_url_eu = (env == 'production') ? 'https://api-eu.panelfox.io/api' : 'http://localhost:8888/api';
    const host = window.location.host;

    if (isEu(host)) {
        api_url = api_url_eu;
    }

    return api_url;
}

function getAccountPrefixUrl(account) {
    if (account && account.custom_domain) {
        return account.custom_domain;
    } else {
        return getDefaultUiUrl();
    }
}

function isEu(host) {
    if (['community.angelfish-opinions.com', 'research.bunnyfield.com', 'eu.panelfox.io'].includes(host)) {
        return true;
    } else {
        return false;
    }
}

const configs = {
    production: {
        is_eu_server: isEu(location_host),
        getAccountPrefixUrl: getAccountPrefixUrl,
        UI_URL: getDefaultUiUrl(),
        API_URL: getDefaultApiUrl(),
        WIDGET_URL: 'https://static.panelfox.io/bundle.js',
        BENNY_TOKEN: 'bc0ed2d3-414a-4624-a2e4-ba0852893f6a',
        stripe_key_public: 'pk_live_z7a9zJ53Hkwaamh6gSYtEOaP',
        ZOOM_CLIENT_ID: 'DYll_tSoTHeyOnmQHTcaVQ',
        AWS_KEY: 'AKIA27D6YW2N65HII4V6',
        AWS_BUCKET: 'panelfox-images-prod',
        PUSHER_KEY: 'c95049b5fdeb64dc3ca4',
        PUSHER_CLUSTER: 'us3',
        MIXPANEL_TOKEN: '430792e559caba328f14491bf59c4a89',
        SUPPORT_EMAIL: SUPPORT_EMAIL
    },
    development: {
        is_eu_server: isEu(location_host),
        getAccountPrefixUrl: getAccountPrefixUrl,
        UI_URL: 'http://localhost:3000',
        API_URL: 'http://localhost:8888/api',
        WIDGET_URL: 'http://localhost:8080/bundle.js',
        BENNY_TOKEN: 'f3926f36-da2c-4f95-a559-0ddd840c36cc',
        stripe_key_public: 'pk_test_9MaBepFjTJE24j6EaCIWzqLa',
        ZOOM_CLIENT_ID: 'YEJViR1WToehDHQdSgCA4w',
        AWS_KEY: 'AKIA27D6YW2N65HII4V6',
        AWS_BUCKET: 'panelfox-images-local',
        PUSHER_KEY: '2b0b36b5a1e86b15063e',
        PUSHER_CLUSTER: 'us3',
        MIXPANEL_TOKEN: 'f4c8754688fc1e4009b2fa3812e64189',
        SUPPORT_EMAIL: SUPPORT_EMAIL
    },
    test: {
        is_eu_server: isEu(location_host),
        getAccountPrefixUrl: getAccountPrefixUrl,
        UI_URL: 'http://localhost:3000',
        API_URL: 'http://localhost:8000/api',
        WIDGET_URL: 'http://localhost:8080/bundle.js',
        BENNY_TOKEN: 'f3926f36-da2c-4f95-a559-0ddd840c36cc',
        stripe_key_public: 'pk_test_9MaBepFjTJE24j6EaCIWzqLa',
        ZOOM_CLIENT_ID: 'YEJViR1WToehDHQdSgCA4w',
        AWS_KEY: 'AKIA27D6YW2N65HII4V6',
        AWS_BUCKET: 'panelfox-images-local',
        PUSHER_KEY: '2b0b36b5a1e86b15063e',
        PUSHER_CLUSTER: 'us3',
        MIXPANEL_TOKEN: 'f4c8754688fc1e4009b2fa3812e64189',
        SUPPORT_EMAIL: SUPPORT_EMAIL
    }
};

export default configs[env];
